import { UIText2 } from '@cian/ui-kit';
import { IconCar16, IconWalk16 } from '@cian/ui-kit/icons';
import * as React from 'react';

import * as styles from './styles.css';
import { ETransportType, IUnderground } from '../../../../types/newbuildingHeader';
import { UndergroundIcon } from '../UndergroundIcon';

interface IUndergroundProps {
  underground: IUnderground;
}

export const Underground: React.FC<IUndergroundProps> = ({ underground }) => {
  return (
    <div className={styles['underground']}>
      <div className={styles['undergroundIcon']}>
        <UndergroundIcon lineColor={underground.lineColor} type={underground.undergroundType} />
      </div>
      <UIText2 color="black_100">{underground.name}</UIText2>
      {underground.timeDisplay && (
        <>
          <div className={styles['travelTimeIcon']}>
            {underground.transportType === ETransportType.Transport ? (
              <IconCar16 color="gray60_100" />
            ) : (
              <IconWalk16 color="gray60_100" />
            )}
          </div>
          <UIText2 color="gray60_100">{underground.timeDisplay}</UIText2>
        </>
      )}
    </div>
  );
};
